import { useQuery } from "react-query";

import { ListOnboardedWTMDomainsResponse } from "../types";
import { makeRequest } from "../../util";

export default function useListOnboardedDomains() {
  return useQuery<ListOnboardedWTMDomainsResponse>(
    "list_onboarded_wtm_domains",
    async () => {
      const res = await makeRequest<ListOnboardedWTMDomainsResponse>(
        "list_onboarded_wtm_domains"
      );

      return res.data;
    }
  );
}
